export function AppFooter() {
  return <footer className="flex flex-col gap-1 border-t px-4 py-4 text-[11px] text-muted-foreground sm:flex-row sm:justify-between md:px-6"><span>TBR Distribuidora · Gestão de Tecnologia da Informação</span><span>Ambiente interno protegido</span></footer>;
}
